// ##################################################
// Feather animation stagger
// ##################################################

document.addEventListener('DOMContentLoaded', () => {
  const mfaSceneFeathersItems = document.querySelectorAll('.featherlight-module__feathers-item');
  if (mfaSceneFeathersItems.length > 0) {
    const mfaSection = document.querySelector('.featherlight-module');
    const mfaSceneOne = document.querySelector('.mfa-scene-one');
    const mfaSceneThree = document.querySelector('.mfa-scene-three');

    // ##################################################
    // Scene one: Vest fade-in
    const timeline1 = gsap.timeline({
      scrollTrigger: {
        trigger: mfaSceneOne,
        start: 'top 80%',
        end: '+=25%',
        scrub: false,
        // markers: true,
      },
    });
    timeline1.to(mfaSceneOne, { opacity: 1 });

    // ##################################################
    // Scene one: vest and scrolling text comes up
    // gsap.timeline({
    //   scrollTrigger: {
    //     trigger: mfaSection,
    //     start: 'top top',
    //     end: '+=100%',
    //     scrub: false,
    //     anticipatePin: 1,
    //     pin: mfaSceneOne,
    //     // markers: true,
    //     // pinType: 'transform',
    //   },
    // });

    const featherLightModule = document.querySelectorAll('.featherlight-module');
    let controllerFeatherLightModule = null;
    controllerFeatherLightModule = new ScrollMagic.Controller();

    const initStickyElementScene = (element, animationDuration, startPoint) => {
      // Sticky scene
      new ScrollMagic.Scene({
        triggerElement: startPoint,
        duration: animationDuration,
        triggerHook: 0,
      })
        .setPin(element)
        // .addIndicators({ name: 'Sticky' })
        .addTo(controllerFeatherLightModule);
    };

    const initAllScenes = () => {
      featherLightModule.forEach((el) => {
        const parent = el.closest('.sc-featherlight-module');
        const stickyElement = parent.querySelector('.mfa-scene-one');
        const stickyStartPoint = parent.querySelector('.featherlight-module__sticky-start');
        initStickyElementScene(stickyElement, '150%', stickyStartPoint);
      });
    };

    initAllScenes();

    // ##################################################
    // Scene two - feathers come up
    gsap.timeline({
      scrollTrigger: {
        trigger: mfaSection,
        start: 'top top',
        end: '+=125%',
        scrub: false,
        // markers: true,
        onUpdate: (self) => {
          mfaSceneFeathersItems.forEach((elem) => {
            const el = elem;
            el.style.transform = `translate3d(0, -${self.progress * 250}%, 0)`;
            el.style.opacity = self.progress * 1.5;
          });
        },
      },
    });

    // ##################################################
    // Scene three - last text come up
    const timeline4 = gsap.timeline({
      scrollTrigger: {
        trigger: mfaSceneThree,
        start: 'center 100%',
        end: '+=100%',
        scrub: false,
      },
    });
    timeline4.to(mfaSceneThree, { opacity: 1 });
  }
});
